module.exports = __webpack_public_path__ + "static/media/VestasSans-Semibold.8193446a.svg";